import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdStatusComponent } from "./hd-status.component";

@NgModule({
  declarations: [
    HdStatusComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgZorroAntdModule,
  ],
  exports: [HdStatusComponent],
  providers: [],
  bootstrap: [HdStatusComponent]
})
export class HdStatusModule {
}
